<template>
	<v-row class="ma-0 pb-offset">
		<v-tabs v-if="loaded && apiRequest && apiRequestExist"
			app
			show-arrows
			:height="32"
			class="tabs-route"
			background-color="transparent"
			slider-color="primary">
				
			<v-tab>Info e Contatti</v-tab>
			<v-tab>Dirigenti</v-tab>
			<v-tab>Attività</v-tab>
			<v-tab>Dipendenti</v-tab>
			<v-tab>Stato Finanziario</v-tab>

			<template>

				<v-tab-item class="background-1 fill-height pt-2">
					<v-row class="ma-0">
						<v-card flat class="flex round-card background-2" :elevation="1">
							<v-card-title class="pa-2">
								<div class="d-flex align-center">
									<v-icon color="primary" class="mr-3" size="24">mdi-domain</v-icon>
									<div>
										<p class="pl-2 pl-xl-3 py-0">{{ businessname }}</p>
										<div class="pl-2 py-0">
											<p class="grey--text card-subtitle">ultimo aggiornamento: {{ apiRequest.created_at | date }} di: {{ (creator ? creator.name : '') }}</p>
										</div>
									</div>
								</div>
								<v-spacer></v-spacer>

								<v-menu
									v-model="showButtonsList[0]" 
									transition="slide-y-transition"
									content-class="round-card"
									:close-on-click="true"
									offset-y 
									min-width="200" 
									nudge-left="50">
									<template v-slot:activator="{ on }">
										<v-btn icon v-on="on" :loading="loading">
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</template>

									<v-list dense>
										<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
										<v-list-item
											ripple
											@click="getFullData()">
											<v-list-item-icon>
												<v-icon style="font-size: 18px">mdi-refresh</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item
											ripple
											@click="copyAllDataToClipboard()">
											<v-list-item-icon>
												<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Copia tutti i dati</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>

							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<div class="d-flex align-center mb-4">
									<v-icon color="info" class="mr-2">mdi-information</v-icon>
									<h3 class="text-h6 font-weight-medium">Dettagli Aziendali</h3>
								</div>
								<v-container fluid>
									<v-row>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="info-card flex border-l-4" 
												outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="primary" class="mr-3">mdi-domain</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Ragione Sociale</div>
														<div class="font-weight-medium">{{ businessname }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="info-card flex border-l-4" 
												outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="primary" class="mr-3">mdi-card-account-details</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">P.IVA</div>
														<div class="font-weight-medium">{{ vatCode }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="info-card flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="primary" class="mr-3">mdi-file-document</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">REA</div>
														<div class="font-weight-medium">{{ reaCode }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="info-card flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="primary" class="mr-3">mdi-office-building</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">CCIAA</div>
														<div class="font-weight-medium">{{ cciaa }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card primary-activity flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" :color="activityStatusDescription == 'Attiva' ? 'success' : 'warning'" class="mr-3">
														{{ activityStatusDescription == 'Attiva' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
													</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Stato Attività</div>
														<div class="font-weight-medium" :class="activityStatusDescription == 'Attiva' ? 'success--text' : 'warning--text'">
															{{ activityStatusDescription }}
														</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-row>

					<v-row class="ma-0 mt-4">
						<v-card flat class="flex round-card background-2" :elevation="1">
							<v-card-title class="pa-2">
								<div class="d-flex align-center py-2">
									<v-icon color="success" class="mr-2">mdi-phone</v-icon>
									<h3 class="text-h6 font-weight-medium">Contatti</h3>
								</div>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container fluid>
									<v-row class="pt-0">
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card primary-activity flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="success" class="mr-3">mdi-phone</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Telefono</div>
														<div class="font-weight-medium">{{ telephone }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card primary-activity flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="success" class="mr-3">mdi-fax</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Fax</div>
														<div class="font-weight-medium">{{ fax }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card primary-activity flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="success" class="mr-3">mdi-email-seal</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">PEC</div>
														<div class="font-weight-medium">{{ pec }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card primary-activity flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="success" class="mr-3">mdi-email</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Email</div>
														<div class="font-weight-medium">{{ email }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
									<v-row>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card sic-primary flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="info" class="mr-3">mdi-web</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Website</div>
														<div class="font-weight-medium">{{ website }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card sic-primary flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="#1877F2" class="mr-3">mdi-facebook</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Facebook</div>
														<div class="font-weight-medium">{{ facebook }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-3 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card sic-primary flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="#0A66C2" class="mr-3">mdi-linkedin</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">LinkedIn</div>
														<div class="font-weight-medium">{{ linkedin }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
								</v-container>
								<v-container fluid>
									<v-row>
										<v-col class="col-12 display-flex py-1 pt-0 round-card">
											<v-card 
												class="activity-card artisan-registry flex border-l-4" 
												outlined>				
												<v-list-item class="pa-3">
													<v-icon size="21" color="warning" class="mr-3">mdi-map-marker</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Indirizzo</div>
														<div class="font-weight-medium">{{ address }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-row>
					
					<v-row class="ma-0 mt-4 pb-4">
						<v-card flat class="flex round-card background-2" :elevation="1">
							<v-card-title class="pa-2">
								<div class="d-flex align-center py-2">
									<v-icon color="purple" class="mr-2">mdi-information-outline</v-icon>
									<h3 class="text-h6 font-weight-medium">Informazioni Generali</h3>
								</div>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container fluid>
									<v-row>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-calendar-today</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Data inizio</div>
														<div class="font-weight-medium" v-if="startDate">{{ formatDate(startDate) }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-calendar-edit</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Data registrazione</div>
														<div class="font-weight-medium" v-if="registrationDate">{{ formatDate(registrationDate) }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-calendar-start</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Data incorporazione</div>
														<div class="font-weight-medium" v-if="incorporationDate">{{ formatDate(incorporationDate) }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
									<v-row>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-scale-balance</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Forma giuridica</div>
														<div class="font-weight-medium" v-if="detailedLegalForm">{{ detailedLegalForm }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>

										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-office-building</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Tipo Sede</div>
														<div class="font-weight-medium" v-if="officeType">{{ officeType }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
										<v-col class="col-12 col-sm-6 col-md-4 col-lg-4 display-flex py-1 pt-0 round-card">
											<v-card class="activity-card group-card flex" outlined>
												<v-list-item class="pa-3">
													<v-icon size="21" color="purple" class="mr-3">mdi-domain-switch</v-icon>
													<div class="align-self-center">
														<div class="text-caption text-uppercase grey--text">Gruppo controllata</div>
														<div class="font-weight-medium" v-if="groupName">{{ groupName }}</div>
													</div>
												</v-list-item>
											</v-card>
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-row>

				</v-tab-item>

				<v-tab-item class="background-1 fill-height pt-2">
					<v-card flat class="round-card background-2 uniform-section" :elevation="1">
						<v-card-title class="pa-2">
							<div class="d-flex align-center">
								<v-icon color="primary" class="mr-3" size="24">mdi-account-tie</v-icon>
								<div>
									<p class="pl-2 pl-xl-3 py-0">{{ businessname }}</p>
									<div class="pl-2 py-0">
										<p class="grey--text card-subtitle">ultimo aggiornamento: {{ apiRequest.created_at | date }} di: {{ (creator ? creator.name : '') }}</p>
									</div>
								</div>
							</div>
							<v-spacer></v-spacer>

							<v-menu
								v-model="showButtonsList[1]" 
								transition="slide-y-transition"
								content-class="round-card"
								:close-on-click="true"
								offset-y 
								min-width="200" 
								nudge-left="50">
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>

								<v-list dense>
									<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
									<v-list-item
										ripple
										@click="getFullData()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-refresh</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item
										ripple
										@click="copyAllDataToClipboard()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Copia tutti i dati</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>

						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<div class="d-flex align-center mb-4">
								<v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
								<h3 class="text-h6 font-weight-medium">Dirigenti e Management</h3>
								<v-spacer></v-spacer>
								<v-chip color="primary" small outlined v-if="managers && managers.length">
									{{ managers.length }} {{ managers.length === 1 ? 'dirigente' : 'dirigenti' }}
								</v-chip>
							</div>

							<div v-if="!managers || managers.length === 0" class="text-center py-8">
								<v-icon size="64" color="grey lighten-2">mdi-account-off-outline</v-icon>
								<p class="grey--text mt-4">Nessun dirigente disponibile</p>
							</div>

							<v-container fluid v-else>
								<v-row>
									<v-col class="col-12 col-sm-6 col-lg-4 py-2" v-for="(manager, m) in managers" :key="m">
										<v-card class="manager-card h-100 border-l-4" outlined elevation="2">
											<v-card-text class="pa-4">
												<!-- Header con nome e badge rappresentante legale -->
												<div class="d-flex align-center mb-3">
													<v-avatar :color="manager.isLegalRepresentative ? 'primary' : 'grey lighten-1'" size="40" class="mr-3">
														<v-icon :color="manager.isLegalRepresentative ? 'white' : 'grey'">
															{{ manager.isLegalRepresentative ? 'mdi-account-star' : 'mdi-account' }}
														</v-icon>
													</v-avatar>
													<div class="flex-grow-1">
														<h4 class="text-h6 font-weight-medium mb-1">{{ managerName(manager) }}</h4>
														<v-chip v-if="manager.isLegalRepresentative" 
															color="primary" 
															small 
															label>
															<v-icon left small>mdi-star</v-icon>
															Rappresentante Legale
														</v-chip>
													</div>
												</div>

												<!-- Ruoli -->
												<div class="mb-3">
													<div class="text-caption grey--text mb-1">RUOLI</div>
													<div v-for="(role, r) in manager.roles" :key="r" class="mb-1">
														<v-chip color="info" small outlined class="mr-1 mb-1">
															{{ role.role ? role.role.description : 'N/A' }}
														</v-chip>
														<div class="text-caption grey--text">
															dal {{ formatDate(role.roleStartDate) }}
														</div>
													</div>
												</div>

												<v-divider class="my-3"></v-divider>

												<!-- Informazioni personali -->
												<div class="personal-info">
													<div class="info-row" v-if="manager.taxCode">
														<v-icon size="16" color="grey" class="mr-2">mdi-card-account-details</v-icon>
														<span class="text-caption grey--text">CF:</span>
														<span class="font-weight-medium ml-1">{{ manager.taxCode }}</span>
													</div>
													<div class="info-row" v-if="manager.birthDate">
														<v-icon size="16" color="grey" class="mr-2">mdi-calendar</v-icon>
														<span class="text-caption grey--text">Nato il:</span>
														<span class="font-weight-medium ml-1">{{ formatDate(manager.birthDate) }}</span>
													</div>
													<div class="info-row" v-if="manager.age">
														<v-icon size="16" color="grey" class="mr-2">mdi-calendar-today</v-icon>
														<span class="text-caption grey--text">Età:</span>
														<span class="font-weight-medium ml-1">{{ manager.age }} anni</span>
													</div>
													<div class="info-row" v-if="manager.birthTown">
														<v-icon size="16" color="grey" class="mr-2">mdi-map-marker</v-icon>
														<span class="text-caption grey--text">Luogo di nascita:</span>
														<span class="font-weight-medium ml-1">{{ manager.birthTown }}</span>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
					
					<!-- Sezione Soci -->
					<v-card flat class="round-card background-2 mt-4 uniform-section" v-if="shareholders && shareholders.length" :elevation="1">
						<v-card-title>
							<div class="d-flex align-center">
								<v-icon color="orange" class="mr-2">mdi-handshake</v-icon>
								<h3 class="text-h6 font-weight-medium">Soci e Partecipazioni</h3>
							</div>
							<v-spacer></v-spacer>
							<div class="d-flex align-center">
								<v-chip color="orange" small outlined>
									{{ shareholders.length }} {{ shareholders.length === 1 ? 'socio' : 'soci' }}
								</v-chip>
							</div>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-container fluid>
								<v-row>
									<v-col class="col-12 col-sm-6 col-lg-4 py-2" v-for="(shareholder, s) in shareholders" :key="s">
										<v-card class="shareholder-card h-100" outlined elevation="2">
											<v-card-text class="pa-4">
												<!-- Header con percentuale e nome -->
												<div class="d-flex align-center mb-3">
													<v-avatar color="orange" size="40" class="mr-3">
														<span class="white--text font-weight-bold">{{ shareholder.percentShare }}%</span>
													</v-avatar>
													<div class="flex-grow-1">
														<h4 class="text-h6 font-weight-medium">
															{{ managerName(shareholder.shareholdersInformation[0]) }}
														</h4>
													</div>
												</div>

												<v-divider class="my-3"></v-divider>

												<!-- Informazioni del socio -->
												<div class="shareholder-info">
													<div class="info-row" v-if="shareholder.shareholdersInformation[0].taxCode">
														<v-icon size="16" color="grey" class="mr-2">mdi-card-account-details</v-icon>
														<span class="text-caption grey--text">CF:</span>
														<span class="font-weight-medium ml-1">{{ shareholder.shareholdersInformation[0].taxCode }}</span>
													</div>
													<div class="info-row" v-if="shareholder.shareholdersInformation[0].streetName || shareholder.shareholdersInformation[0].town">
														<v-icon size="16" color="grey" class="mr-2">mdi-map-marker</v-icon>
														<span class="text-caption grey--text">Indirizzo:</span>
														<span class="font-weight-medium ml-1">
															{{ shareholder.shareholdersInformation[0].streetName }} - 
															{{ shareholder.shareholdersInformation[0].town }} 
															{{ shareholder.shareholdersInformation[0].zipCode }}
														</span>
													</div>
													<div class="info-row" v-if="shareholder.shareholdersInformation[0].sinceDate">
														<v-icon size="16" color="grey" class="mr-2">mdi-calendar-clock</v-icon>
														<span class="text-caption grey--text">Socio dal:</span>
														<span class="font-weight-medium ml-1">{{ formatDate(shareholder.shareholdersInformation[0].sinceDate) }}</span>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
					
					<!-- Sezione Gruppo Controllata -->
					<v-card flat class="round-card background-2 mt-4 uniform-section group-section" v-if="corporateGroups && corporateGroups.belongsToGroup" :elevation="1">
						<v-card-title>
							<div class="d-flex align-center">
								<v-icon color="purple" class="mr-2">mdi-domain-switch</v-icon>
								<h3 class="text-h6 font-weight-medium">Informazioni Gruppo</h3>
							</div>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<!-- Informazioni sul gruppo -->
							<v-container fluid>
								<v-row>
									<v-col cols="12">
										<v-card class="group-card h-100" outlined elevation="2">
											<v-card-text class="pa-4">
												<div class="d-flex align-center">
													<v-avatar color="purple" size="48" class="mr-4">
														<v-icon color="white" size="24">mdi-office-building</v-icon>
													</v-avatar>
													<div>
														<div class="info-row mb-2">
															<span class="text-caption grey--text">GRUPPO:</span>
															<h4 class="font-weight-bold">{{ corporateGroups.groupName }}</h4>
														</div>
														<div class="info-row">
															<span class="text-caption grey--text">HOLDING:</span>
															<span class="font-weight-medium">{{ corporateGroups.holdingCompanyName }}</span>
														</div>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item class="background-1 fill-height pt-2">
					<v-card flat class="round-card background-2" :elevation="1">
						<v-card-title class="pa-2">
							<div class="d-flex align-center">
								<v-icon color="primary" class="mr-3" size="24">mdi-factory</v-icon>
								<div>
									<p class="pl-2 pl-xl-3 py-0">{{ businessname }}</p>
									<div class="pl-2 py-0">
										<p class="grey--text card-subtitle">ultimo aggiornamento: {{ apiRequest.created_at | date }} di: {{ (creator ? creator.name : '') }}</p>
									</div>
								</div>
							</div>
							<v-spacer></v-spacer>

							<v-menu
								v-model="showButtonsList[2]" 
								transition="slide-y-transition"
								content-class="round-card"
								:close-on-click="true"
								offset-y 
								min-width="200" 
								nudge-left="50">
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>

								<v-list dense>
									<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
									<v-list-item
										ripple
										@click="showFullData()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-refresh</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item
										ripple
										@click="copyAllDataToClipboard()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Copia tutti i dati</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>

						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<!-- Classificazione ATECO -->
							<div class="d-flex align-center mb-4">
								<v-icon color="green" class="mr-2">mdi-factory</v-icon>
								<h3 class="text-h6 font-weight-medium">Classificazione ATECO</h3>
							</div>
							<v-container fluid>
								<!-- Attività Principale -->
								<v-row class="mb-4">
									<v-col cols="12">
										<div class="text-subtitle-1 font-weight-medium mb-3 d-flex align-center">
											<v-icon color="green" class="mr-2" size="20">mdi-star</v-icon>
											Attività Principale
										</div>
										<v-card class="activity-card primary-activity" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-items-center">
													<div class="flex-grow-1">
														<h4 class="font-weight-bold mb-1">{{ atecoClassification.description }}</h4>
														<v-chip color="green" small label>
															<v-icon left small>mdi-tag</v-icon>
															Codice: {{ atecoClassification.code }}
														</v-chip>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>

								<!-- Attività Secondarie -->
								<v-row class="mb-4" v-if="atecoSecondaryClassification">
									<v-col cols="12">
										<div class="text-subtitle-1 font-weight-medium mb-3 d-flex align-center">
											<v-icon color="green lighten-1" class="mr-2" size="20">mdi-star-half-full</v-icon>
											Attività Secondarie
										</div>
										<v-card class="activity-card secondary-activity" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-items-center">
													<v-avatar color="green lighten-1" size="40" class="mr-3">
														<v-icon color="white">mdi-factory</v-icon>
													</v-avatar>
													<div>
														<div class="font-weight-medium">{{ atecoSecondaryClassification }}</div>
														<div class="text-caption grey--text">Attività complementare</div>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>

								<!-- Registro Artigiani -->
								<v-row class="mb-4">
									<v-col cols="12">
										<div class="text-subtitle-1 font-weight-medium mb-3 d-flex align-center">
											<v-icon color="orange" class="mr-2" size="20">mdi-hammer-wrench</v-icon>
											Registro Artigiani
										</div>
										<v-card class="activity-card artisan-registry" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-items-center">
													<v-avatar :color="artisanBusinessRegistry ? 'orange' : 'grey lighten-2'" size="40" class="mr-3">
														<v-icon :color="artisanBusinessRegistry ? 'white' : 'grey'">
															{{ artisanBusinessRegistry ? 'mdi-check' : 'mdi-close' }}
														</v-icon>
													</v-avatar>
													<div>
														<div class="font-weight-medium">
															{{ artisanBusinessRegistry ? 'Registrata come Impresa Artigiana' : 'Non registrata come Impresa Artigiana' }}
														</div>
														<div class="text-caption grey--text">
															{{ artisanBusinessRegistry ? 'L\'azienda è iscritta al Registro delle Imprese Artigiane' : 'L\'azienda non risulta iscritta al Registro Artigiani' }}
														</div>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
					
					<!-- Classificazione SIC -->
					<v-card flat class="round-card background-2 mt-4" :elevation="1">
						<v-card-title>
							<div class="d-flex align-center">
								<v-icon color="blue" class="mr-2">mdi-earth</v-icon>
								<h3 class="text-h6 font-weight-medium">Classificazione SIC (Standard Industrial Classification)</h3>
							</div>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-container fluid>
								<!-- SIC Principale -->
								<v-row class="mb-4">
									<v-col cols="12">
										<div class="text-subtitle-1 font-weight-medium mb-3 d-flex align-center">
											<v-icon color="blue" class="mr-2" size="20">mdi-star</v-icon>
											Classificazione Principale
										</div>
										<v-card class="activity-card sic-primary" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-items-center">
													<div class="flex-grow-1">
														<h4 class="font-weight-bold mb-1">{{ atecoClassification.code }} - {{ atecoClassification.description }}</h4>
														<v-chip color="blue" small label>
															<v-icon left small>mdi-earth</v-icon>
															Classificazione Internazionale
														</v-chip>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>

								<!-- SIC Secondarie -->
								<v-row v-if="atecoSecondaryClassification">
									<v-col cols="12">
										<div class="text-subtitle-1 font-weight-medium mb-3 d-flex align-center">
											<v-icon color="blue lighten-1" class="mr-2" size="20">mdi-star-half-full</v-icon>
											Classificazioni Secondarie
										</div>
										<v-card class="activity-card sic-secondary" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-items-center">
													<v-avatar color="blue lighten-1" size="40" class="mr-3">
														<v-icon color="white">mdi-earth</v-icon>
													</v-avatar>
													<div>
														<div class="font-weight-medium">{{ atecoSecondaryClassification }}</div>
														<div class="text-caption grey--text">Attività complementare secondo standard SIC</div>
													</div>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item class="background-1 fill-height pt-2">
					<v-card flat class="flex round-card background-2 mb-4" :elevation="1">
						<v-card-title class="pa-2">
							<div class="d-flex align-center">
								<v-icon color="primary" class="mr-3" size="24">mdi-account-group</v-icon>
								<div>
									<p class="pl-2 pl-xl-3 py-0">{{ businessname }}</p>
									<div class="pl-2 py-0">
										<p class="grey--text card-subtitle">ultimo aggiornamento: {{ apiRequest.created_at | date }} di: {{ (creator ? creator.name : '') }}</p>
									</div>
								</div>
							</div>
							<v-spacer></v-spacer>

							<v-menu
								v-model="showButtonsList[3]" 
								transition="slide-y-transition"
								content-class="round-card"
								:close-on-click="true"
								offset-y 
								min-width="200" 
								nudge-left="50">
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>

								<v-list dense>
									<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
									<v-list-item
										ripple
										@click="getFullData()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-refresh</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item
										ripple
										@click="copyAllDataToClipboard()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Copia tutti i dati</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>

						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<div class="d-flex align-center mb-4">
								<v-icon color="teal" class="mr-2">mdi-account-multiple</v-icon>
								<h3 class="text-h6 font-weight-medium">Informazioni sui Dipendenti</h3>
							</div>

							<div v-if="!employee && !employeeRange" class="text-center py-8">
								<v-icon size="64" color="grey lighten-2">mdi-account-off-outline</v-icon>
								<p class="grey--text mt-4">Nessuna informazione sui dipendenti disponibile</p>
							</div>

							<v-container fluid v-else>
								<v-row>
									<!-- Card numero dipendenti -->
									<v-col cols="12" sm="6" md="6" lg="6">
										<v-card class="employee-card" color="teal" dark elevation="3">
											<v-card-text class="text-center pa-6">
												<v-avatar color="white" size="64" class="mb-4">
													<v-icon color="teal" size="32">mdi-account-group</v-icon>
												</v-avatar>
												<div class="text-h3 font-weight-bold mb-2">{{ employee || 'N/A' }}</div>
												<div class="text-h6 font-weight-medium">Dipendenti</div>
												<div class="text-caption mt-2">Numero totale di dipendenti registrati</div>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- Card fascia dipendenti -->
									<v-col cols="12" sm="6" md="6" lg="6">
										<v-card class="employee-range-card" color="teal lighten-1" dark elevation="3">
											<v-card-text class="text-center pa-6">
												<v-avatar color="white" size="64" class="mb-4">
													<v-icon color="teal lighten-1" size="32">mdi-chart-bar</v-icon>
												</v-avatar>
												<div class="text-h3 font-weight-bold mb-2">{{ employeeRange ? employeeRange.description : 'N/A' }}</div>
												<div class="text-h6 font-weight-medium">Fascia Aziendale</div>
												<div class="text-caption mt-2">Classificazione dimensionale dell'azienda</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>

								<!-- Informazioni aggiuntive sui dipendenti -->
								<v-row class="mt-4" v-if="employee || employeeRange">
									<v-col cols="12">
										<v-card class="employee-details-card" outlined>
											<v-card-text class="pa-4">
												<div class="d-flex align-center mb-3">
													<v-icon color="info" class="mr-2">mdi-information</v-icon>
													<h4 class="text-h6 font-weight-medium">Dettagli sull'Organico</h4>
												</div>
												
												<v-divider class="my-3"></v-divider>

												<div class="employee-metrics">
													<v-row>
														<v-col cols="12" sm="6" md="3">
															<div class="metric-item">
																<div class="metric-icon">
																	<v-avatar color="info lighten-4" size="40">
																		<v-icon color="info">mdi-account</v-icon>
																	</v-avatar>
																</div>
																<div class="metric-content">
																	<div class="text-caption grey--text">TOTALE DIPENDENTI</div>
																	<div class="text-h6 font-weight-bold">{{ employee || 'Non disponibile' }}</div>
																</div>
															</div>
														</v-col>
														<v-col cols="12" sm="6" md="3">
															<div class="metric-item">
																<div class="metric-icon">
																	<v-avatar color="success lighten-4" size="40">
																		<v-icon color="success">mdi-trending-up</v-icon>
																	</v-avatar>
																</div>
																<div class="metric-content">
																	<div class="text-caption grey--text">CATEGORIA</div>
																	<div class="text-subtitle-2 font-weight-bold">{{ getCompanySizeCategory(employee) }}</div>
																</div>
															</div>
														</v-col>
														<v-col cols="12" sm="6" md="3">
															<div class="metric-item">
																<div class="metric-icon">
																	<v-avatar color="warning lighten-4" size="40">
																		<v-icon color="warning">mdi-chart-line</v-icon>
																	</v-avatar>
																</div>
																<div class="metric-content">
																	<div class="text-caption grey--text">FASCIA</div>
																	<div class="text-subtitle-2 font-weight-bold">{{ employeeRange ? employeeRange.description : 'N/A' }}</div>
																</div>
															</div>
														</v-col>
														<v-col cols="12" sm="6" md="3">
															<div class="metric-item">
																<div class="metric-icon">
																	<v-avatar color="purple lighten-4" size="40">
																		<v-icon color="purple">mdi-office-building</v-icon>
																	</v-avatar>
																</div>
																<div class="metric-content">
																	<div class="text-caption grey--text">DIMENSIONE</div>
																	<div class="text-subtitle-2 font-weight-bold">{{ getCompanySize(employee) }}</div>
																</div>
															</div>
														</v-col>
													</v-row>
												</div>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
				</v-tab-item>
				
				<v-tab-item class="background-1 fill-height pt-2 pb-offset">
					<v-card flat class="flex round-card background-2" :elevation="1">
						<v-card-title class="pa-2">
							<div class="d-flex align-center">
								<v-icon color="primary" class="mr-3" size="24">mdi-chart-line</v-icon>
								<div>
									<p class="pl-2 pl-xl-3 py-0">{{ businessname }}</p>
									<div class="pl-2 py-0">
										<p class="grey--text card-subtitle">ultimo aggiornamento: {{ apiRequest.created_at | date }} di: {{ (creator ? creator.name : '') }}</p>
									</div>
								</div>
							</div>
							<v-spacer></v-spacer>

							<v-menu
								v-model="showButtonsList[4]" 
								transition="slide-y-transition"
								content-class="round-card"
								:close-on-click="true"
								offset-y 
								min-width="200" 
								nudge-left="50">
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>

								<v-list dense>
									<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
									<v-list-item
										ripple
										@click="showFullData()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-refresh</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item
										ripple
										@click="copyAllDataToClipboard()">
										<v-list-item-icon>
											<v-icon style="font-size: 18px">mdi-content-copy</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>Copia tutti i dati</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>

						</v-card-title>
						<v-divider></v-divider>
						
						<!-- Sezione dati finanziari migliorata -->
						<v-card-text class="pa-0">
							<div v-if="!apiRequestResponse || !hasFinancialData" class="text-center py-8">
								<v-icon size="64" color="grey lighten-2">mdi-chart-box-outline</v-icon>
								<p class="grey--text mt-4">Nessun dato finanziario disponibile</p>
							</div>
							
							<div v-else>
								<!-- Indicatori principali in evidenza -->
								<v-container fluid class="py-4 mb-4">
									<v-row v-if="getMainFinancialIndicators.length > 0">
										<v-col cols="12">
											<h3 class="text-h6 font-weight-medium mb-4 d-flex align-center">
												<v-icon color="primary" class="mr-2">mdi-trending-up</v-icon>
												Indicatori Principali
											</h3>
										</v-col>
										<v-col 
											v-for="indicator in getMainFinancialIndicators" 
											:key="indicator.label"
											cols="12" sm="6" md="4" lg="3">
											<v-card 
												class="financial-indicator-card" 
												:color="getCardColor(indicator.value)" 
												dark
												elevation="3">
												<v-card-text class="text-center pa-4">
													<v-icon size="32" class="mb-2">{{ getIconForIndicator(indicator.label) }}</v-icon>
													<div class="text-h6 font-weight-bold mb-1">{{ indicator.value | currency }}</div>
													<div class="text-caption">{{ indicator.label }}</div>
												</v-card-text>
											</v-card>
										</v-col>
									</v-row>
								</v-container>

								<v-divider></v-divider>
								<v-container fluid class="pa-0">
									<!-- Sezioni dettagliate organizzate -->
									<v-row v-for="(section, sectionIndex) in organizedFinancialData" :key="sectionIndex" class="elevation-0">
										<v-expansion-panels 
											v-model="expandedPanels" 
											multiple
											class="pb-">
											<v-expansion-panel>
												<v-expansion-panel-header class="text-h6 font-weight-medium">
													<div class="d-flex align-center">
														<v-icon :color="section.color" class="mr-3">{{ section.icon }}</v-icon>
														{{ section.title }}
														<v-spacer></v-spacer>
														<v-chip 
															:color="section.color" 
															small 
															outlined 
															class="mr-4">
															{{ section.items.length }} voci
														</v-chip>
													</div>
												</v-expansion-panel-header>
												<v-expansion-panel-content>
													<v-container class="pa-0" fluid>
														<v-row class="mx-0">
															<v-col 
																v-for="(item, itemIndex) in section.items" 
																:key="itemIndex"
																cols="12" sm="6" md="4">
																<v-card 
																	class="mb-3 info-card flex border-l-4" 
																	outlined
																	flat>
																	<v-card-text class="pa-3">
																		<div class="d-flex justify-space-between align-center">
																			<div class="financial-item-label">{{ item.text }}</div>
																			<div 
																				class="financial-item-value font-weight-bold" 
																				:class="getValueColorClass(item.value)">
																				{{ item.value | currency }}
																			</div>
																		</div>
																		<v-progress-linear
																			v-if="item.percentage"
																			:value="item.percentage"
																			:color="section.color"
																			height="4"
																			class="mt-2">
																		</v-progress-linear>
																	</v-card-text>
																</v-card>
															</v-col>
														</v-row>
													</v-container>
												</v-expansion-panel-content>
												<v-divider></v-divider>

											</v-expansion-panel>
										</v-expansion-panels>
									</v-row>
								</v-container>
							</div>
						</v-card-text>
					</v-card>
				</v-tab-item>

			</template>
		</v-tabs>

		<v-card v-else flat class="flex round-card background-2" :elevation="1">
			<v-card-title class="pa-2">
				<div>
					<p class="pl-2 pl-xl-3">{{ company ? company.business_name : '' }}</p>
				</div>
				<div>
					<p class="entity-title">&nbsp;&nbsp;{{ company ? company.vat_number : '' }}</p>
				</div>
				<v-spacer></v-spacer>
				<v-menu
					v-model="showButtonsList[0]" 
					transition="slide-y-transition"
					content-class="round-card"
					:close-on-click="true"
					offset-y 
					min-width="200" 
					nudge-left="50">
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" :loading="loading">
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>

					<v-list dense>
						<v-subheader class="pt-2 fs12i" style="height:38px">Azioni</v-subheader>
						<v-list-item
							ripple
							@click="getFullData()">
							<v-list-item-icon>
								<v-icon style="font-size: 18px">mdi-refresh</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>Richiedi informazioni aggiornate</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="text-center py-8" v-if="this.isPending">Richiesta effettuata da {{ creator ? creator.name : '' }}, il {{ apiRequest.created_at | date }}, attendere completamento</v-card-text>
			<v-card-text class="text-center py-8" v-else-if="this.isFailed == 'failed'">I dati per la società {{ company.business_name }} non sono disponibili</v-card-text>
			<v-card-text class="text-center py-8" v-else>Non sono state effettuate ancora ricerche per questa azienda</v-card-text>
			<v-card-text class="text-center pt-1">
				<v-btn text small ripple @click="getFullData()" :loading="loading" :disabled="disabledRequest" color="primary" class="fs11i" style="margin:auto">Richiedi Informazioni</v-btn>
			</v-card-text>
		</v-card>
		

	</v-row>
</template>

<script>

	export default {
		name: 'business-data',
		props: {
			id: Number,
		},
		data() {
			return {
				apiRequest: {},
				company: null,
				loaded: false,
				loading: false,
				apiRequestExist: false,
				disabledRequest: true,
				showButtonsList: {},
				expandedPanels: [0, 1, 2], // Primi 3 pannelli aperti di default
				financialKeys: ['Valori Aggregati degli Asset', 'Crediti agli Azionisti', 'Asset Immateriale', 'Asset Tangibile', 'Asset Finanziari', 'Inventario', 'Crediti', 'Asset Finanziari', 'Equivalente in Contanti', 'Valori Aggregati dei Debiti', 'Patrimonio Netto', 'Provisioni per Rischi', 'Debiti', 'Valori Aggregati del Conto Economico', 'Valore della Produzione', 'Costi di Produzione', 'Ricavi e Oneri Finanziari', 'Regolazioni', 'Risultato Annuale', 'Rapporti di Copertura', 'Sviluppo']

			}
		},

		computed: {
			apiRequestResponse() {
				if(this.apiRequest && this.apiRequest.response && this.apiRequest.response.data) {
					return this.apiRequest.response.data
				}
				return null
			},
			responseStatusTransalte() {
				if(this.apiRequest && this.apiRequest.status) {
					if(this.apiRequest.status == 'pending') {
						return 'Richiesta in corso'
					} else if(this.apiRequest.status == 'completed') {
						return 'Richiesta completata'
					}
				}
				return ''
			},
			isCompleted() {
				if(this.apiRequest?.status) {
					return this.apiRequest.status == 'completed'
				}
				return false
			},
			isFailed() {
				if(this.apiRequest?.status) {
					return this.apiRequest.status == 'failed'
				}
				return false
			},
			isPending() {
				if(this.apiRequest?.status) {
					return this.apiRequest.status == 'pending'
				}
				return false
			},
			creator() {
				return this.apiRequest?.creator || null
			},
			activityStatusDescription() {
				const status = this.apiRequestResponse?.companyStatus?.activityStatus?.description
				return status === 'Enable' ? 'Attiva' : status || ''
			},
			businessname() {
				return this.apiRequestResponse?.companyDetails?.companyName || ''
			},
			vatCode() {
				return this.apiRequestResponse?.companyDetails?.vatCode || ''
			},
			reaCode() {
				return this.apiRequestResponse?.companyDetails?.reaCode || ''
			},
			cciaa() {
				return this.apiRequestResponse?.companyDetails?.cciaa || ''
			},
			officeType() {
				return this.apiRequestResponse?.companyDetails?.officeType?.description || ''
			},
			telephone() {
				return this.apiRequestResponse?.contacts?.telephoneNumber || ''
			},
			fax() {
				return this.apiRequestResponse?.contacts?.fax || ''
			},
			pec() {
				return this.apiRequestResponse?.pec || ''
			},
			email() {
				return this.apiRequestResponse?.mail?.email || ''
			},
			startDate() {
				return this.apiRequestResponse?.companyDates?.startDate || ''
			},
			registrationDate() {
				return this.apiRequestResponse?.companyDates?.registrationDate || ''
			},
			incorporationDate() {
				return this.apiRequestResponse?.companyDates?.incorporationDate || ''
			},
			address() {
				const address = this.apiRequestResponse?.address
				return address 
					? `${address.streetName} ${address.town} (${address.province.code}) ${address.zipCode} ${address.country.code}`
					: ''
			},
			detailedLegalForm() {
				return this.apiRequestResponse?.legalForm?.detailedLegalForm?.description || ''
			},
			website() {
				return this.apiRequestResponse?.webAndSocial?.website?.replace(/^https?:\/\//, '') || ''
			},
			facebook() {
				return this.apiRequestResponse?.webAndSocial?.facebook?.replace(/^https?:\/\//, '') || ''
			},
			linkedin() {
				return this.apiRequestResponse?.webAndSocial?.linkedin?.replace(/^https?:\/\//, '') || ''
			},
			groupName() {
				return this.apiRequestResponse?.corporateGroups?.groupName || ''
			},
			managers() {
				return this.apiRequestResponse?.managers || ''
			},
			managerName() {
				return (manager) => manager?.name && manager?.surname 
					? `${manager.name} ${manager.surname}` 
					: manager?.companyName || ''
			},
			employee() {
				return this.apiRequestResponse?.employees?.employee || ''
			},
			employeeRange() {
				return this.apiRequestResponse?.employees?.employeeRange || ''
			},
			atecoClassification() {
				return this.apiRequestResponse?.atecoClassification?.ateco || ''
			},
			atecoSecondaryClassification() {
				return this.apiRequestResponse?.atecoClassification?.secondaryAteco || ''
			},
			artisanBusinessRegistry() {
				return this.apiRequestResponse?.artisanBusinessRegistry?.belongsToArtisanBusinessRegistry || ''
			},
			internationalClassificationNace() {
				return this.apiRequestResponse?.internationalClassification?.nace || ''
			},
			internationalClassificationPrimarySic() {
				return this.apiRequestResponse?.internationalClassification?.primarySic || ''
			},
			internationalClassificationSecondarySic() {
				return this.apiRequestResponse?.internationalClassification?.secondarySic || ''
			},
			shareholders() {
				return this.apiRequestResponse?.shareholders || ''
			},
			corporateGroups() {
				return this.apiRequestResponse?.corporateGroups || ''
			},

			// Computed properties per i dati finanziari
			hasFinancialData() {
				if (!this.apiRequestResponse) return false
				return this.financialKeys.some(key => 
					this.apiRequestResponse[key] && 
					Array.isArray(this.apiRequestResponse[key]) && 
					this.apiRequestResponse[key].length > 0
				)
			},

			getMainFinancialIndicators() {
				const indicators = []
				if (!this.apiRequestResponse) return indicators

				// Cerca indicatori principali
				const mainKeys = [
					'Valori Aggregati degli Asset',
					'Patrimonio Netto', 
					'Valore della Produzione',
					'Risultato Annuale'
				]

				mainKeys.forEach(key => {
					if (this.apiRequestResponse[key] && this.apiRequestResponse[key].length > 0) {
						const item = this.apiRequestResponse[key][0]
						if (item && item.value && item.value !== '0' && item.value !== 'N/A') {
							indicators.push({
								label: item.text || key,
								value: item.value,
								key: key
							})
						}
					}
				})

				return indicators
			},

			organizedFinancialData() {
				if (!this.apiRequestResponse) return []

				const sections = [
					{
						title: 'Patrimonio e Asset',
						icon: 'mdi-bank',
						color: 'blue',
						keys: ['Valori Aggregati degli Asset', 'Asset Immateriale', 'Asset Tangibile', 'Asset Finanziari', 'Inventario']
					},
					{
						title: 'Crediti e Liquidità',
						icon: 'mdi-cash-multiple',
						color: 'green',
						keys: ['Crediti', 'Crediti agli Azionisti', 'Equivalente in Contanti']
					},
					{
						title: 'Debiti e Passività',
						icon: 'mdi-credit-card-outline',
						color: 'orange',
						keys: ['Valori Aggregati dei Debiti', 'Debiti', 'Provisioni per Rischi']
					},
					{
						title: 'Patrimonio Netto',
						icon: 'mdi-trending-up',
						color: 'purple',
						keys: ['Patrimonio Netto']
					},
					{
						title: 'Conto Economico',
						icon: 'mdi-chart-line',
						color: 'teal',
						keys: ['Valori Aggregati del Conto Economico', 'Valore della Produzione', 'Costi di Produzione', 'Risultato Annuale']
					},
					{
						title: 'Analisi e Rapporti',
						icon: 'mdi-chart-box',
						color: 'indigo',
						keys: ['Ricavi e Oneri Finanziari', 'Regolazioni', 'Rapporti di Copertura', 'Sviluppo']
					}
				]

				return sections.map(section => {
					const items = []
					section.keys.forEach(key => {
						if (this.apiRequestResponse[key] && Array.isArray(this.apiRequestResponse[key])) {
							this.apiRequestResponse[key].forEach(item => {
								if (item.value && item.value !== '0' && item.value !== 'N/A') {
									items.push({
										text: item.text,
										value: item.value,
										percentage: this.calculatePercentage(item.value, section.keys)
									})
								}
							})
						}
					})
					
					return {
						...section,
						items: items
					}
				}).filter(section => section.items.length > 0)
			},
		},

		methods: {

			// Metodi per la visualizzazione finanziaria
			getCardColor(value) {
				if (!value || value === 'N/A') return 'grey'
				
				const numValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''))
				if (numValue > 1000000) return 'success'
				if (numValue > 100000) return 'info'
				if (numValue > 0) return 'warning'
				return 'error'
			},

			getIconForIndicator(label) {
				const iconMap = {
					'Asset': 'mdi-domain',
					'Patrimonio': 'mdi-bank',
					'Produzione': 'mdi-factory',
					'Risultato': 'mdi-trending-up',
					'Ricavi': 'mdi-cash-plus',
					'Debiti': 'mdi-credit-card-minus'
				}

				for (const [key, icon] of Object.entries(iconMap)) {
					if (label.toLowerCase().includes(key.toLowerCase())) {
						return icon
					}
				}
				return 'mdi-chart-box'
			},

			getValueColorClass(value) {
				if (!value || value === 'N/A') return 'grey--text'
				
				const numValue = parseFloat(value.toString().replace(/[^0-9.-]/g, ''))
				if (numValue > 0) return 'success--text'
				if (numValue < 0) return 'error--text'
				return 'grey--text'
			},

			calculatePercentage(value, sectionKeys) {
				// Calcola una percentuale relativa per la barra di progresso
				if (!value || value === 'N/A') return 0
				
				const numValue = Math.abs(parseFloat(value.toString().replace(/[^0-9.-]/g, '')))
				if (numValue === 0) return 0
				
				// Trova il valore massimo nella sezione per calcolare la percentuale
				let maxValue = 0
				sectionKeys.forEach(key => {
					if (this.apiRequestResponse[key]) {
						this.apiRequestResponse[key].forEach(item => {
							if (item.value && item.value !== 'N/A') {
								const itemValue = Math.abs(parseFloat(item.value.toString().replace(/[^0-9.-]/g, '')))
								if (itemValue > maxValue) maxValue = itemValue
							}
						})
					}
				})
				
				return maxValue > 0 ? Math.min((numValue / maxValue) * 100, 100) : 0
			},

			// Metodi per il tab Dipendenti
			getCompanySizeCategory(employees) {
				if (!employees || employees === 'N/A') return 'Non disponibile'
				
				const num = parseInt(employees)
				if (num <= 10) return 'Micro Impresa'
				if (num <= 50) return 'Piccola Impresa'
				if (num <= 250) return 'Media Impresa'
				return 'Grande Impresa'
			},

			getCompanySize(employees) {
				if (!employees || employees === 'N/A') return 'Non classificata'
				
				const num = parseInt(employees)
				if (num <= 5) return 'Molto Piccola'
				if (num <= 15) return 'Piccola'
				if (num <= 50) return 'Media'
				if (num <= 100) return 'Grande'
				if (num <= 250) return 'Molto Grande'
				return 'Enterprise'
			},

			// Metodo per copiare tutti i dati nella clipboard
			copyAllDataToClipboard() {
				try {
					let clipboardText = `DATI AZIENDALI - ${this.businessname}\n`
					clipboardText += `Ultimo aggiornamento: ${this.apiRequest.created_at ? this.$eventBusUtility.formatDate(this.apiRequest.created_at) : 'N/A'}\n`
					clipboardText += `Aggiornato da: ${this.creator ? this.creator.name : 'N/A'}\n\n`

					// Informazioni generali
					clipboardText += `=== INFORMAZIONI GENERALI ===\n`
					clipboardText += `Ragione Sociale: ${this.businessname || 'N/A'}\n`
					clipboardText += `P.IVA: ${this.vatCode || 'N/A'}\n`
					clipboardText += `REA: ${this.reaCode || 'N/A'}\n`
					clipboardText += `CCIAA: ${this.cciaa || 'N/A'}\n`
					clipboardText += `Stato Attività: ${this.activityStatusDescription || 'N/A'}\n`
					clipboardText += `Forma Giuridica: ${this.detailedLegalForm || 'N/A'}\n`
					clipboardText += `Tipo Sede: ${this.officeType || 'N/A'}\n`
					clipboardText += `Data Inizio: ${this.startDate ? this.formatDate(this.startDate) : 'N/A'}\n`
					clipboardText += `Data Registrazione: ${this.registrationDate ? this.formatDate(this.registrationDate) : 'N/A'}\n`
					clipboardText += `Data Incorporazione: ${this.incorporationDate ? this.formatDate(this.incorporationDate) : 'N/A'}\n\n`

					// Contatti
					clipboardText += `=== CONTATTI ===\n`
					clipboardText += `Telefono: ${this.telephone || 'N/A'}\n`
					clipboardText += `Fax: ${this.fax || 'N/A'}\n`
					clipboardText += `Email: ${this.email || 'N/A'}\n`
					clipboardText += `PEC: ${this.pec || 'N/A'}\n`
					clipboardText += `Website: ${this.website || 'N/A'}\n`
					clipboardText += `Facebook: ${this.facebook || 'N/A'}\n`
					clipboardText += `LinkedIn: ${this.linkedin || 'N/A'}\n`
					clipboardText += `Indirizzo: ${this.address || 'N/A'}\n\n`

					// Dirigenti
					if (this.managers && this.managers.length > 0) {
						clipboardText += `=== DIRIGENTI ===\n`
						this.managers.forEach((manager, index) => {
							clipboardText += `${index + 1}. ${this.managerName(manager)}\n`
							if (manager.isLegalRepresentative) {
								clipboardText += `   - Rappresentante Legale\n`
							}
							if (manager.roles && manager.roles.length > 0) {
								manager.roles.forEach(role => {
									clipboardText += `   - ${role.role ? role.role.description : 'N/A'} dal ${this.formatDate(role.roleStartDate)}\n`
								})
							}
							clipboardText += `   - CF: ${manager.taxCode || 'N/A'}\n`
							clipboardText += `   - Nato il: ${manager.birthDate ? this.formatDate(manager.birthDate) : 'N/A'}\n`
							clipboardText += `   - Età: ${manager.age || 'N/A'} anni\n`
							clipboardText += `   - Luogo di nascita: ${manager.birthTown || 'N/A'}\n\n`
						})
					}

					// Soci
					if (this.shareholders && this.shareholders.length > 0) {
						clipboardText += `=== SOCI ===\n`
						this.shareholders.forEach((shareholder, index) => {
							const shareholderInfo = shareholder.shareholdersInformation[0]
							clipboardText += `${index + 1}. ${this.managerName(shareholderInfo)} (${shareholder.percentShare}%)\n`
							clipboardText += `   - CF: ${shareholderInfo.taxCode || 'N/A'}\n`
							clipboardText += `   - Indirizzo: ${shareholderInfo.streetName || ''} ${shareholderInfo.town || ''} ${shareholderInfo.zipCode || ''}\n`
							clipboardText += `   - Socio dal: ${shareholderInfo.sinceDate ? this.formatDate(shareholderInfo.sinceDate) : 'N/A'}\n\n`
						})
					}

					// Gruppo
					if (this.corporateGroups && this.corporateGroups.belongsToGroup) {
						clipboardText += `=== GRUPPO ===\n`
						clipboardText += `Gruppo: ${this.corporateGroups.groupName || 'N/A'}\n`
						clipboardText += `Holding: ${this.corporateGroups.holdingCompanyName || 'N/A'}\n\n`
					}

					// Attività
					clipboardText += `=== ATTIVITÀ ===\n`
					clipboardText += `ATECO Principale: ${this.atecoClassification.code || 'N/A'} - ${this.atecoClassification.description || 'N/A'}\n`
					clipboardText += `ATECO Secondaria: ${this.atecoSecondaryClassification || 'N/A'}\n`
					clipboardText += `Registro Artigiani: ${this.artisanBusinessRegistry ? 'Sì' : 'No'}\n\n`

					// Dipendenti
					clipboardText += `=== DIPENDENTI ===\n`
					clipboardText += `Numero Dipendenti: ${this.employee || 'N/A'}\n`
					clipboardText += `Fascia: ${this.employeeRange ? this.employeeRange.description : 'N/A'}\n`
					clipboardText += `Categoria: ${this.getCompanySizeCategory(this.employee)}\n`
					clipboardText += `Dimensione: ${this.getCompanySize(this.employee)}\n\n`

					// Dati finanziari
					if (this.hasFinancialData) {
						clipboardText += `=== DATI FINANZIARI ===\n`
						this.financialKeys.forEach(key => {
							if (this.apiRequestResponse[key] && Array.isArray(this.apiRequestResponse[key]) && this.apiRequestResponse[key].length > 0) {
								clipboardText += `${key}:\n`
								this.apiRequestResponse[key].forEach(item => {
									if (item.value && item.value !== '0' && item.value !== 'N/A') {
										clipboardText += `  - ${item.text}: ${item.value}\n`
									}
								})
								clipboardText += `\n`
							}
						})
					}

					// Copia nella clipboard
					navigator.clipboard.writeText(clipboardText).then(() => {
						this.$toast.success('Dati copiati nella clipboard!', {
							position: 'top-right',
							timeout: 3000,
							closeOnClick: true,
							pauseOnFocusLoss: true,
							pauseOnHover: true,
							draggable: true,
							draggablePercent: 0.6,
							showCloseButtonOnHover: false,
							hideProgressBar: false,
							closeButton: 'button',
							icon: true,
							rtl: false
						})
					}).catch(err => {
						console.error('Errore durante la copia:', err)
						// Fallback per browser più vecchi
						const textArea = document.createElement('textarea')
						textArea.value = clipboardText
						document.body.appendChild(textArea)
						textArea.select()
						document.execCommand('copy')
						document.body.removeChild(textArea)
						
						this.$toast.success('Dati copiati nella clipboard!', {
							position: 'top-right',
							timeout: 3000
						})
					})
				} catch (error) {
					console.error('Errore durante la generazione dei dati:', error)
					this.$toast.error('Errore durante la copia dei dati', {
						position: 'top-right',
						timeout: 3000
					})
				}
			},

			// Metodo helper per formattare le date
			formatDate(date) {
				if (!date) return 'N/A'
				try {
					return new Date(date).toLocaleDateString('it-IT')
				} catch (error) {
					return date
				}
			},

			showFullData() {
				this.loading = true
				this.axios.get(`companies-showfulldata-openapi/${this.id}`).then(response => {

					if(response.data?.data?.id && response.data?.data?.status == 'completed') {
						this.apiRequestExist = true
					} 
					if(response.data.data == null) {
						this.disabledRequest = false
					}
					this.apiRequest = response.data ? response.data.data : null
					this.company = response.data ? response.data.company : null
					this.$store.commit('endProgress')
					this.loaded = true
					this.loading = false

				}, response => {
					// error callback
				})
			},

			getFullData() {
				this.loading = true
				this.axios.get(`companies-getfulldata-openapi/${this.id}`).then(response => {
					this.apiRequestExist = false
					if(response.data?.data?.id && response.data?.data?.status == 'completed') {
						this.apiRequestExist = true
					} 
					if(response.data.data != null && response.data.data.status == 'initiated') {
						this.disabledRequest = true
					}
					this.apiRequest = response.data ? response.data.data : null
					this.company = response.data ? response.data.company : null
					this.$store.commit('endProgress')
					this.loaded = true
					this.loading = false

				}, response => {
					// error callback
				})
			}
		},	

		created() {
			this.showFullData()
		},
	}
</script>

<style scoped>
/* ============================================
   STILI BASE PER LE CARD
   ============================================ */

/* Transizioni base per tutte le card */
.financial-indicator-card,
.financial-item-card,
.info-card,
.manager-card,
.shareholder-card,
.group-card,
.activity-card,
.employee-card,
.employee-range-card,
.employee-details-card {
	transition: all 0.2s ease-in-out;
}

/* ============================================
   EFFETTI HOVER COMUNI
   ============================================ */

/* Hover con bordo sinistro primary dinamico */
.info-card.border-l-4:hover,
.manager-card.border-l-4:hover,
.financial-item-card.border-l-4:hover {
	border-left-color: var(--primary-color) !important;
	border-left-width: 4px !important;
}

/* Hover con trasformazione verso l'alto */
.financial-indicator-card:hover,
.info-card:hover,
.manager-card:hover,
.shareholder-card:hover,
.activity-card:hover,
.employee-details-card:hover {
	transform: translateY(-2px);
}

/* Hover con trasformazione laterale */
.financial-item-card:hover {
	transform: translateX(4px);
}

/* Hover con trasformazione più pronunciata */
.employee-card:hover,
.employee-range-card:hover {
	transform: translateY(-4px);
}

/* ============================================
   EFFETTI OMBRA
   ============================================ */

/* Ombra leggera */
.financial-item-card:hover,
.info-card:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Ombra media */
.manager-card:hover,
.shareholder-card:hover,
.activity-card:hover,
.employee-details-card:hover {
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12) !important;
}

/* Ombra pronunciata */
.employee-card:hover,
.employee-range-card:hover {
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

/* ============================================
   BORDI COLORATI SPECIFICI
   ============================================ */

/* Card soci - colore arancione */
.shareholder-card:hover {
	border-left-color: #FF9800 !important;
	border-left-width: 4px !important;
}

/* Card gruppo - colore viola */
.group-card:hover {
	border-left-color: #9C27B0 !important;
	border-left-width: 4px !important;
}

/* Card dipendenti - colore teal */
.employee-details-card:hover {
	border-left-color: #009688 !important;
	border-left-width: 4px !important;
}

/* Attività primaria - verde */
.primary-activity:hover {
	border-left-color: #4CAF50 !important;
	border-left-width: 4px !important;
}

/* Attività secondaria - verde chiaro */
.secondary-activity:hover {
	border-left-color: #8BC34A !important;
	border-left-width: 4px !important;
}

/* Registro artigiani - arancione */
.artisan-registry:hover {
	border-left-color: #FF9800 !important;
	border-left-width: 4px !important;
}

/* SIC primario - blu */
.sic-primary:hover {
	border-left-color: #2196F3 !important;
	border-left-width: 4px !important;
}

/* SIC secondario - blu chiaro */
.sic-secondary:hover {
	border-left-color: #64B5F6 !important;
	border-left-width: 4px !important;
}

/* ============================================
   LAYOUT E TIPOGRAFIA
   ============================================ */

/* Sezioni uniformi per altezza omogenea */
.uniform-section {
	min-height: 400px;
	display: flex;
	flex-direction: column;
}

/* Sezione gruppo con contenuto semplice - altezza ridotta */
.uniform-section.group-section {
	min-height: 200px;
}

.uniform-section .v-card-text {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.uniform-section .v-container {
	flex: 1;
}

/* Card interne con altezza uniforme */
.manager-card.h-100,
.shareholder-card.h-100 {
	min-height: 280px;
	height: 100%;
}

/* Card del gruppo nella sezione dirigenti (con uniform-section) */
.uniform-section .group-card {
	min-height: 280px;
	height: 100%;
}

/* Card del gruppo nella sezione specifica gruppo - altezza ridotta */
.uniform-section.group-section .group-card {
	min-height: 120px;
	height: auto;
}

/* Card delle informazioni generali - altezza compatta */
.activity-card.group-card.flex {
	min-height: auto;
	height: auto;
}

.activity-card.group-card.flex .v-list-item {
	min-height: 72px;
	padding: 8px 12px;
}

/* Elementi delle info rows */
.personal-info .info-row,
.shareholder-info .info-row {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	font-size: 0.875rem;
}

/* Elementi finanziari */
.financial-item-label {
	font-size: 0.9rem;
	flex: 1;
}

.financial-item-value {
	font-size: 1rem;
	text-align: right;
}

/* Metriche dipendenti */
.employee-metrics .metric-item {
	display: flex;
	align-items: center;
	padding: 12px 0;
}

.employee-metrics .metric-icon {
	margin-right: 16px;
}

.employee-metrics .metric-content {
	flex: 1;
}

/* ============================================
   ELEMENTI SPECIFICI DI VUETIFY
   ============================================ */

/* Override per v-list-item nelle info-card */
.info-card .v-list-item {
	min-height: auto;
}

/* Override per expansion panel header */
.v-expansion-panel-header {
	padding: 16px 24px;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

/* Ottimizzazioni per dispositivi mobili */
@media (max-width: 600px) {
	/* Riduci altezza minima sezioni su mobile */
	.uniform-section {
		min-height: 300px;
	}
	
	/* Sezione gruppo rimane compatta su mobile */
	.uniform-section.group-section {
		min-height: 150px;
	}
	
	/* Riduci altezza minima card su mobile */
	.manager-card.h-100,
	.shareholder-card.h-100 {
		min-height: 200px;
	}
	
	.uniform-section .group-card {
		min-height: 200px;
	}
	
	/* Card gruppo nella sezione specifica rimane molto compatta su mobile */
	.uniform-section.group-section .group-card {
		min-height: 100px;
	}
	
	/* Card informazioni generali rimangono compatte su mobile */
	.activity-card.group-card.flex .v-list-item {
		min-height: 64px;
		padding: 6px 10px;
	}
	
	.financial-item-label {
		font-size: 0.8rem;
	}
	
	.financial-item-value {
		font-size: 0.9rem;
	}
	
	.info-card .v-list-item {
		padding: 12px;
	}
	
	.manager-card .v-card-text,
	.shareholder-card .v-card-text {
		padding: 16px;
	}
	
	.personal-info .info-row,
	.shareholder-info .info-row {
		font-size: 0.8rem;
	}
	
	.employee-metrics .metric-item {
		flex-direction: column;
		text-align: center;
		padding: 16px 8px;
	}
	
	.employee-metrics .metric-icon {
		margin-right: 0;
		margin-bottom: 8px;
	}
}

/* Ottimizzazioni per tablet */
@media (min-width: 601px) and (max-width: 960px) {
	.uniform-section {
		min-height: 350px;
	}
	
	/* Sezione gruppo ridotta anche su tablet */
	.uniform-section.group-section {
		min-height: 175px;
	}
	
	.manager-card.h-100,
	.shareholder-card.h-100 {
		min-height: 240px;
	}
	
	.uniform-section .group-card {
		min-height: 240px;
	}
	
	/* Card gruppo nella sezione specifica su tablet */
	.uniform-section.group-section .group-card {
		min-height: 110px;
	}
}
</style>